import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { AppButton, Logo, WhatsAppButton } from '@/components/atoms';
import { SocialIconLinks } from '@/components/molecules';
import { type FooterContent } from '@/hooks/useFooterContent';

/** Logo, sales pitch, benefits and the two calls to action. */
export function FooterBrand({ brand }: { brand: FooterContent['brand'] }) {
  return (
    <Stack spacing={5} sx={{ maxWidth: 440 }}>
      <Logo height={72} />

      <Box
        sx={{
          alignSelf: 'flex-start',
          px: 3,
          py: 1,
          borderRadius: 999,
          bgcolor: 'rgba(var(--mui-palette-primary-mainChannel) / 0.08)',
          color: 'primary.main',
          typography: 'caption',
          fontWeight: 700,
          letterSpacing: '0.04em',
        }}
      >
        {brand.badge}
      </Box>

      <Typography component="p" variant="h5">
        {brand.pitch}
      </Typography>

      <Stack component="ul" spacing={2.5} sx={{ listStyle: 'none', p: 0, m: 0 }}>
        {brand.highlights.map((h) => (
          <Stack key={h.title} component="li" direction="row" spacing={2.5}>
            <CheckCircleRounded
              aria-hidden
              sx={{ fontSize: 20, mt: '2px', color: 'primary.main' }}
            />
            <Typography variant="body2" color="text.secondary">
              {h.title}
            </Typography>
          </Stack>
        ))}
      </Stack>

      <Stack direction="row" flexWrap="wrap" useFlexGap spacing={3}>
        <AppButton to={brand.quoteCta.to}>{brand.quoteCta.label}</AppButton>
        <WhatsAppButton message={brand.whatsappMessage} />
      </Stack>

      <SocialIconLinks />
    </Stack>
  );
}
